import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "FILTRE PAR CATÉGORIE")
], -1)
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "flex justify-between card-header border-0 pt-6" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "my-1" }
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Action", -1)

import {ref, onMounted} from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import {fetchPaginatedCategories} from "@/_services/category/category";
import {ICategory} from "@/models/category/ICategory";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterableCategoryList',
  setup(__props) {

const loading = ref<boolean>(true);
const categories: ICategory[] = [];
const tableData = ref<Array<ICategory>>(categories);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");

onMounted(async () => {
    await populateDatatable(rows.value, page.value);
});

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    criteria?: string,
    sort?: {
        fieldLabel: string;
        fieldValue: string
    }
) => {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchPaginatedCategories(
        itemsPerPage,
        page,
        null,
        criteria,
        sort
    );

    loading.value = loadingDt.value;
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
};

const onPaginate = async (e: { rows: number; page: number; }) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable(e.rows, e.page + 1, criteria.value);
};

const onFilterDt = () => {
    if (criteria.value != "") {
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        populateDatatable(rows.value, page.value);
    }
};

const showSpinner = () => {
    loading.value = true;
}

const hideSpinner = () => {
    loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        rowHover: true,
        loading: loading.value,
        rowsPerPageOptions: [10, 30, 50, 100],
        lazy: "",
        paginator: "",
        template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: _cache[1] || (_cache[1] = ($event: any) => (onPaginate($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "form-control w-[250px] ps-15",
                    placeholder: "Rechercher une catégorie",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                    onKeyup: _withKeys(onFilterDt, ["enter"]),
                    onInput: onClearInputFilter
                  }, null, 8, ["modelValue", "onKeyup"])
                ])
              ])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucune catégorie trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Catégorie"
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_9
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  to: { name: 'categoryProductFiltersManagement', params: { uuid: slotProps.data.uuid }}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      type: "button",
                      icon: "pi pi-eye ",
                      title: "Voir les filtres de la catégories",
                      class: "p-button-success p-button-eye ml-2"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ])
  ], 64))
}
}

})